import React from 'react'
import { navigate } from 'gatsby'
import getClickableProps from '../../Clickble/Clickable'
import SearchIcon from '../../Icons/Search/Search'
import { CloseButton } from 'react-bootstrap';
import "./Search.css";

const NavSearch = ({onSubmit = null, buttonLabel = null, afterSearch = null, startSearch = null, searchValue = null, isOpen = false, closeHandler = null, awardType = null}) => {
  const toggleButtonRef = React.useRef()
  const inputRef = React.useRef()
  const [open, setOpen] = React.useState(isOpen)
  const [initOpen, setInitOpen] = React.useState(true)
  const [searchType, setSearchType] = React.useState(awardType)
  const [defaultValue, setDefaultValue] = React.useState(searchValue)

  // setup the position for the overlay to grow and shrink from
  const [closePosition, setClosePosition] = React.useState({top: 0, left: 0})
  const updateClosePosition = React.useCallback(() => {
    setClosePosition({
      top: toggleButtonRef.current ? toggleButtonRef.current.offsetTop + toggleButtonRef.current.offsetHeight / 2 : 0,
      left: toggleButtonRef.current ? toggleButtonRef.current.offsetLeft + toggleButtonRef.current.offsetWidth / 2 : 0,
    })
  }, [toggleButtonRef, setClosePosition])

  const resetSearch = (type) => {
    setTimeout(() => {
      navigate(`/home/${type}`)
      if (startSearch) startSearch()
    }, 1000)
  }

  const resetValue = () => {
    setTimeout(() => {
      setDefaultValue("")
      inputRef.current.value = ""
    }, 1000)
  }

  const toggleOpenAndUpdateCenter = React.useCallback((type) => {
    setSearchType(type)
    if (!open && searchValue) {
      setInitOpen(false)
      resetSearch(type)
      resetValue()
    } else {
      if (open || (!open && searchValue)) {
        resetValue()
        resetSearch(type)
        if (closeHandler) closeHandler()
      }
      setOpen(!open)
    }
    updateClosePosition()
  }, [open, setOpen, updateClosePosition, setInitOpen, initOpen, searchValue])

  React.useEffect(updateClosePosition, [toggleButtonRef])

  // setup the search redirect on entering a search term
  const handleOnSubmit = React.useCallback((...args) => {
    if (inputRef.current.value.length > 0) {
      if (onSubmit !== null) {
        return onSubmit(...args)
      } else {
        navigate(`/home/${searchType}?text=${encodeURI(inputRef.current.value)}`)
        if (startSearch) startSearch()
      }

      if (afterSearch !== null) {
        afterSearch(...args)
      }
    }
  }, [onSubmit, afterSearch, searchType, startSearch])

  React.useEffect(() => {
    if (!isOpen) setOpen(false)
  },[awardType, isOpen])

  return (
    <>
      <div
        className="search-button  d-none d-lg-block"
        ref={toggleButtonRef}
        {...getClickableProps(() => toggleOpenAndUpdateCenter(awardType))}
      >
        {buttonLabel || <SearchIcon />}
      </div>
      <div className={`search-overlay ${awardType} ${open || (searchValue && initOpen) ? "open" : ""}`} style={closePosition}>
        <input
          placeholder="Search for projects, companies and people"
          onSubmit={handleOnSubmit}
          onKeyDown={(e) => {e.key === "Enter" && handleOnSubmit(e)}}
          ref={inputRef}
          defaultValue={defaultValue}
        />
        <div
          className="search-button"
          ref={toggleButtonRef}
          {...getClickableProps(handleOnSubmit)}
        >
          <SearchIcon />
        </div>
        <div
          className="close-button"
          {...getClickableProps(() => toggleOpenAndUpdateCenter(awardType))}
        >
          <CloseButton />
        </div>
      </div>
    </>
  )
}

export default NavSearch;
